var Backbone, EmailFormV2FlexibleContactChannelsView, SupportV2FlexibleContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2FlexibleContactChannelsTemplate = require('../../../../v2_flexible_contact_channels.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormV2FlexibleContactChannelsView = (function(superClass) {
  extend(EmailFormV2FlexibleContactChannelsView, superClass);

  function EmailFormV2FlexibleContactChannelsView() {
    return EmailFormV2FlexibleContactChannelsView.__super__.constructor.apply(this, arguments);
  }

  EmailFormV2FlexibleContactChannelsView.prototype.className = 'flexible-contact-channels-view-v2';

  EmailFormV2FlexibleContactChannelsView.prototype.events = {
    'DOMSubtreeModified .flexible-contact-channels-container  #live-chat-container': 'handleDisplayOfLiveChatIcon',
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container': 'handleDisplayOfPrimaryLiveChatLink',
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container': 'handleDisplayOfSecondaryLiveChatLink',
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container': 'handleDisplayOfTertiaryLiveChatLink',
    'click .flexible-email-container': 'renderEmailForm',
    'click .flexible-phone-container': 'renderPhoneView',
    'click .flex-email-link': 'renderEmailForm',
    'click .flex-phone-link': 'renderPhoneView',
    'click .flex-chat-link': 'renderChatClickView',
    'click .primary-chat-link#live-chat-link-container': 'renderChatClickView',
    'click .flexible-contact-channels-container  #live-chat-container': 'renderChatClickView'
  };

  EmailFormV2FlexibleContactChannelsView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportV2FlexibleContactChannelsTemplate;
    this.model = Groupon.Support.FlexibleContactChannelModel;
    return this.mainView = this.options.mainView;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.render = function() {
    var options;
    this.model.presentContactChannels();
    this.$el.empty();
    options = {
      renderLayout: true,
      withoutChat: !this.isLiveChatEnabled()
    };
    this.$el.append(this.arrangeLayoutView(this.toHash(options)));
    return this;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.LiveChatModel.isLiveChatEnabled();
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderEmailForm = function(e) {
    return this.mainView.renderEmailForm();
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderPhoneView = function() {
    return this.mainView.renderPhoneNumberView();
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderChatClickView = function() {
    return this.mainView.renderChatClickView();
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfLiveChatIcon = function() {
    this.$el.find('.flex-contact-channels-without-chat').empty();
    this.setFlexibleLiveChatDisplayCallBack(this.handleDisplayOfLiveChatIcon);
    if (this.isLiveChatIconVisible()) {
      window.showDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      return window.hideDOMElems($('.flex-contact-channels-without-chat'));
    } else {
      window.hideDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      window.showDOMElems($('.flex-contact-channels-without-chat'));
      return $('.flex-contact-channels-without-chat').html(this.arrangeLayoutView(this.toHash({
        withoutChat: true
      })));
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfPrimaryLiveChatLink = function() {
    var primaryChatTextElem;
    primaryChatTextElem = $(".flex-chat-channel-text");
    return this.toggleDomElemsBasedOnLiveChat(primaryChatTextElem);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfSecondaryLiveChatLink = function() {
    var DOMelemsToToggle, flexTertiaryOrTextElem, secondaryFlexibleLiveChatContainerElem;
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem];
    if (this.model.get('formattedContactChannels').contact_channels.length === 2) {
      DOMelemsToToggle.push($('.flex-secondary-channel-also-text'));
    }
    return this.toggleDomElemsBasedOnLiveChat(DOMelemsToToggle);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfTertiaryLiveChatLink = function() {
    var flexTertiaryOrTextElem, tertiaryFlexibleLiveChatContainerElem;
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    return this.toggleDomElemsBasedOnLiveChat([tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.toggleDomElemsBasedOnLiveChat = function(domElems) {
    if (window.liveChatLinkVisible()) {
      return window.showDOMElemsInline(domElems);
    } else {
      window.removeDOMElemsInline(domElems);
      return window.hideDOMElems(domElems);
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.setFlexibleLiveChatDisplayCallBack = function(liveChatDisplayCallback) {
    return window.setLiveChatDisplayCallBack($('a img', this.liveChatIconContainer()), liveChatDisplayCallback);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.isLiveChatIconVisible = function() {
    return window.liveChatVisible($('a img', this.liveChatIconContainer()));
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfContactChannels = function() {
    if (this.liveChatIconContainer().length > 0) {
      return this.handleDisplayOfLiveChatIcon();
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.liveChatIconContainer = function() {
    return $('.flexible-contact-channels-container #live-chat-container');
  };

  EmailFormV2FlexibleContactChannelsView.prototype.toHash = function(arg) {
    var additionalInfo, contactChannelhash, hash, renderLayout, withoutChat;
    withoutChat = arg.withoutChat, renderLayout = arg.renderLayout;
    contactChannelhash = {};
    if (withoutChat) {
      contactChannelhash = this.model.get('contactChannelsWithoutBoldChat');
    } else if (this.model.has('formattedContactChannels')) {
      contactChannelhash = this.model.get('formattedContactChannels');
    } else {
      contactChannelhash = this.model.get('contactChannelsWithoutBoldChat');
    }
    additionalInfo = {
      orderMsg: this.setOrderInfo(),
      issueMsg: this.setIssueInfo(),
      isCallBackAvailable: window.evaluate(window.experiments.shouldDisplayCallBackOption)
    };
    if (renderLayout) {
      additionalInfo.renderLayout = true;
    }
    hash = $.extend(true, additionalInfo, contactChannelhash);
    return hash;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.setOrderInfo = function() {
    var order, ref, ref1, title;
    order = Groupon.Support.currentOrder;
    if (order) {
      title = ((ref = order.deal) != null ? ref.title : void 0) || ((ref1 = order.merchant) != null ? ref1.name : void 0);
      if (title) {
        return I18n.translate('js.modules.support.issue_about_this_order', {
          dealTitle: title
        });
      }
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.setIssueInfo = function() {
    var issue, ref;
    issue = Groupon.Support.ContentModel.getSearchInputIssue() || ((ref = Groupon.Support.ContentModel.getSubCategory()) != null ? ref.text : void 0);
    if (issue) {
      return I18n.translate('js.modules.support.saw_you_have_issue', {
        issue: issue
      });
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.arrangeLayoutView = function(hash) {
    var $container, $html, html;
    html = toHtml(this.template, hash, this.I18nScope);
    $html = $(html);
    $container = this.arrangeLayoutOfIcons(hash, $html);
    return $container;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.addBloodHoundTagToIcon = function(channel, $container, type) {
    var contactElem;
    contactElem = this.getContactChannelIcon(channel, $container);
    addBloodHoundTagToDOMElems(contactElem, type + "-" + channel + "-icon");
    return contactElem;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.addAttributesToPrimaryIcon = function(primaryContactChannel, $container) {
    var primaryContactElem;
    primaryContactElem = this.addBloodHoundTagToIcon(primaryContactChannel.channel, $container, "primary");
    addPreferredContactClass(primaryContactElem);
    addBtnPrimaryClass(primaryContactElem);
    return primaryContactElem;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderIcons = function(orderedContactChannelElements, $container) {
    var contactChannelElement, i, len, results;
    $('.flexible-contact-channel-icon-container', $container).empty();
    results = [];
    for (i = 0, len = orderedContactChannelElements.length; i < len; i++) {
      contactChannelElement = orderedContactChannelElements[i];
      results.push($('.flexible-contact-channel-icon-container', $container).append(contactChannelElement));
    }
    return results;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.arrangeLayoutOfIcons = function(hash, $container) {
    var contact_channel, i, len, orderedContactChannelElements, primaryContactElem, ref, ref1;
    orderedContactChannelElements = [];
    if (hash.contact_channels != null) {
      ref = hash.contact_channels;
      for (i = 0, len = ref.length; i < len; i++) {
        contact_channel = ref[i];
        if ((ref1 = contact_channel.primary) != null ? ref1.channel : void 0) {
          primaryContactElem = this.addAttributesToPrimaryIcon(contact_channel.primary, $container);
          orderedContactChannelElements.push(primaryContactElem);
        }
      }
      this.renderIcons(orderedContactChannelElements, $container);
    }
    return $container;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.getContactChannelIcon = function(type, $container) {
    var contactElem;
    switch (type) {
      case "chat":
        contactElem = this.liveChatIconElem($container);
        break;
      case "email":
        contactElem = this.emailIconElem($container);
        break;
      case "phone":
        contactElem = this.phoneIconElem($container);
    }
    return contactElem;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.emailIconElem = function($container) {
    return $('.flexible-contact-channel-icon-container .flexible-email-container', $container);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.phoneIconElem = function($container) {
    return $('.flexible-contact-channel-icon-container .flexible-phone-container', $container);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.liveChatIconElem = function($container) {
    return $('.flexible-contact-channel-icon-container .flexible-chat-container', $container);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderLiveChat = function() {
    if (this.model.get('liveChatExists')) {
      if (this.model.get("primaryChannelIsBoldChat")) {
        this.mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleV2LiveChatType()
        });
      }
      return this.mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: this.model.get("primaryChannelIsBoldChat")
      });
    }
  };

  return EmailFormV2FlexibleContactChannelsView;

})(Backbone.View);

module.exports = EmailFormV2FlexibleContactChannelsView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vdjJfZmxleGlibGVfY29udGFjdF9jaGFubmVscy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL2NvbW1vbi92Ml9mbGV4aWJsZV9jb250YWN0X2NoYW5uZWxzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLDBGQUFBO0VBQUE7OztBQUFBLHdDQUFBLEdBQTJDLE9BQUEsQ0FBUSx3REFBUjs7QUFDM0MsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7bURBQ0osU0FBQSxHQUFXOzttREFDWCxNQUFBLEdBQ0U7SUFBQSwrRUFBQSxFQUFrRiw2QkFBbEY7SUFDQSxnRUFBQSxFQUFtRSxvQ0FEbkU7SUFFQSxrRUFBQSxFQUFxRSxzQ0FGckU7SUFHQSxpRUFBQSxFQUFvRSxxQ0FIcEU7SUFJQSxpQ0FBQSxFQUFtQyxpQkFKbkM7SUFLQSxpQ0FBQSxFQUFtQyxpQkFMbkM7SUFNQSx3QkFBQSxFQUEwQixpQkFOMUI7SUFPQSx3QkFBQSxFQUEwQixpQkFQMUI7SUFRQSx1QkFBQSxFQUF5QixxQkFSekI7SUFTQSxtREFBQSxFQUFxRCxxQkFUckQ7SUFVQSxrRUFBQSxFQUFvRSxxQkFWcEU7OzttREFZRixVQUFBLEdBQVksU0FBQyxPQUFEO0lBQ1YsSUFBQyxDQUFBLE9BQUQsR0FBVyxPQUFBLElBQVc7SUFDdEIsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFWLENBQWdCLENBQWhCLEVBQW1CLENBQUMsSUFBRCxDQUFNLENBQUMsTUFBUCxDQUFjLENBQUMsQ0FBQyxTQUFGLENBQVksSUFBWixDQUFkLENBQW5CO0lBQ0EsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7SUFDWixJQUFDLENBQUEsS0FBRCxHQUFTLE9BQU8sQ0FBQyxPQUFPLENBQUM7V0FDekIsSUFBQyxDQUFBLFFBQUQsR0FBWSxJQUFDLENBQUEsT0FBTyxDQUFDO0VBTlg7O21EQVFaLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUMsQ0FBQSxLQUFLLENBQUMsc0JBQVAsQ0FBQTtJQUNBLElBQUMsQ0FBQSxHQUFHLENBQUMsS0FBTCxDQUFBO0lBQ0EsT0FBQSxHQUNFO01BQUEsWUFBQSxFQUFhLElBQWI7TUFDQSxXQUFBLEVBQWEsQ0FBSSxJQUFDLENBQUEsaUJBQUQsQ0FBQSxDQURqQjs7SUFFRixJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxJQUFDLENBQUEsaUJBQUQsQ0FBbUIsSUFBQyxDQUFBLE1BQUQsQ0FBUSxPQUFSLENBQW5CLENBQVo7V0FDQTtFQVBNOzttREFTUixpQkFBQSxHQUFtQixTQUFBO1dBQ2pCLE9BQU8sQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLGlCQUE5QixDQUFBO0VBRGlCOzttREFHbkIsZUFBQSxHQUFpQixTQUFDLENBQUQ7V0FDZixJQUFDLENBQUEsUUFBUSxDQUFDLGVBQVYsQ0FBQTtFQURlOzttREFHakIsZUFBQSxHQUFpQixTQUFBO1dBQ2YsSUFBQyxDQUFBLFFBQVEsQ0FBQyxxQkFBVixDQUFBO0VBRGU7O21EQUdqQixtQkFBQSxHQUFxQixTQUFBO1dBQ25CLElBQUMsQ0FBQSxRQUFRLENBQUMsbUJBQVYsQ0FBQTtFQURtQjs7bURBR3JCLDJCQUFBLEdBQTZCLFNBQUE7SUFDM0IsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUscUNBQVYsQ0FBZ0QsQ0FBQyxLQUFqRCxDQUFBO0lBQ0EsSUFBQyxDQUFBLGtDQUFELENBQW9DLElBQUMsQ0FBQSwyQkFBckM7SUFDQSxJQUFHLElBQUMsQ0FBQSxxQkFBRCxDQUFBLENBQUg7TUFDRSxNQUFNLENBQUMsWUFBUCxDQUFvQixDQUFBLENBQUUsNkRBQUYsQ0FBcEI7YUFDQSxNQUFNLENBQUMsWUFBUCxDQUFvQixDQUFBLENBQUUscUNBQUYsQ0FBcEIsRUFGRjtLQUFBLE1BQUE7TUFJRSxNQUFNLENBQUMsWUFBUCxDQUFvQixDQUFBLENBQUUsNkRBQUYsQ0FBcEI7TUFDQSxNQUFNLENBQUMsWUFBUCxDQUFvQixDQUFBLENBQUUscUNBQUYsQ0FBcEI7YUFDQSxDQUFBLENBQUUscUNBQUYsQ0FBd0MsQ0FBQyxJQUF6QyxDQUE4QyxJQUFDLENBQUEsaUJBQUQsQ0FBbUIsSUFBQyxDQUFBLE1BQUQsQ0FBUTtRQUFDLFdBQUEsRUFBYSxJQUFkO09BQVIsQ0FBbkIsQ0FBOUMsRUFORjs7RUFIMkI7O21EQVc3QixrQ0FBQSxHQUFvQyxTQUFBO0FBQ2xDLFFBQUE7SUFBQSxtQkFBQSxHQUFzQixDQUFBLENBQUUseUJBQUY7V0FDdEIsSUFBQyxDQUFBLDZCQUFELENBQStCLG1CQUEvQjtFQUZrQzs7bURBSXBDLG9DQUFBLEdBQXNDLFNBQUE7QUFDcEMsUUFBQTtJQUFBLHNDQUFBLEdBQXlDLENBQUEsQ0FBRSw4QkFBRjtJQUN6QyxzQkFBQSxHQUF5QixDQUFBLENBQUUsdUJBQUY7SUFDekIsZ0JBQUEsR0FBbUIsQ0FBQyxzQ0FBRCxFQUF5QyxzQkFBekM7SUFDbkIsSUFBRyxJQUFDLENBQUEsS0FBSyxDQUFDLEdBQVAsQ0FBVywwQkFBWCxDQUFzQyxDQUFDLGdCQUFnQixDQUFDLE1BQXhELEtBQWtFLENBQXJFO01BQTRFLGdCQUFnQixDQUFDLElBQWpCLENBQXNCLENBQUEsQ0FBRSxtQ0FBRixDQUF0QixFQUE1RTs7V0FDQSxJQUFDLENBQUEsNkJBQUQsQ0FBK0IsZ0JBQS9CO0VBTG9DOzttREFPdEMsbUNBQUEsR0FBcUMsU0FBQTtBQUNuQyxRQUFBO0lBQUEscUNBQUEsR0FBd0MsQ0FBQSxDQUFFLDZCQUFGO0lBQ3hDLHNCQUFBLEdBQXlCLENBQUEsQ0FBRSx1QkFBRjtXQUN6QixJQUFDLENBQUEsNkJBQUQsQ0FBK0IsQ0FBQyxxQ0FBRCxFQUF3QyxzQkFBeEMsQ0FBL0I7RUFIbUM7O21EQUtyQyw2QkFBQSxHQUE4QixTQUFDLFFBQUQ7SUFDNUIsSUFBRyxNQUFNLENBQUMsbUJBQVAsQ0FBQSxDQUFIO2FBQ0UsTUFBTSxDQUFDLGtCQUFQLENBQTBCLFFBQTFCLEVBREY7S0FBQSxNQUFBO01BR0UsTUFBTSxDQUFDLG9CQUFQLENBQTRCLFFBQTVCO2FBQ0EsTUFBTSxDQUFDLFlBQVAsQ0FBb0IsUUFBcEIsRUFKRjs7RUFENEI7O21EQU85QixrQ0FBQSxHQUFvQyxTQUFDLHVCQUFEO1dBQ2xDLE1BQU0sQ0FBQywwQkFBUCxDQUFrQyxDQUFBLENBQUUsT0FBRixFQUFXLElBQUMsQ0FBQSxxQkFBRCxDQUFBLENBQVgsQ0FBbEMsRUFBd0UsdUJBQXhFO0VBRGtDOzttREFHcEMscUJBQUEsR0FBdUIsU0FBQTtXQUNyQixNQUFNLENBQUMsZUFBUCxDQUF1QixDQUFBLENBQUUsT0FBRixFQUFXLElBQUMsQ0FBQSxxQkFBRCxDQUFBLENBQVgsQ0FBdkI7RUFEcUI7O21EQUd2Qiw4QkFBQSxHQUFnQyxTQUFBO0lBQzlCLElBQUcsSUFBQyxDQUFBLHFCQUFELENBQUEsQ0FBd0IsQ0FBQyxNQUF6QixHQUFrQyxDQUFyQzthQUNFLElBQUMsQ0FBQSwyQkFBRCxDQUFBLEVBREY7O0VBRDhCOzttREFJaEMscUJBQUEsR0FBdUIsU0FBQTtXQUNyQixDQUFBLENBQUUsMkRBQUY7RUFEcUI7O21EQUd2QixNQUFBLEdBQVEsU0FBQyxHQUFEO0FBQ04sUUFBQTtJQURRLCtCQUFhO0lBQ3JCLGtCQUFBLEdBQXFCO0lBQ3JCLElBQUcsV0FBSDtNQUNFLGtCQUFBLEdBQXFCLElBQUMsQ0FBQSxLQUFLLENBQUMsR0FBUCxDQUFXLGdDQUFYLEVBRHZCO0tBQUEsTUFFSyxJQUFHLElBQUMsQ0FBQSxLQUFLLENBQUMsR0FBUCxDQUFXLDBCQUFYLENBQUg7TUFDSCxrQkFBQSxHQUFxQixJQUFDLENBQUEsS0FBSyxDQUFDLEdBQVAsQ0FBVywwQkFBWCxFQURsQjtLQUFBLE1BQUE7TUFHSCxrQkFBQSxHQUFxQixJQUFDLENBQUEsS0FBSyxDQUFDLEdBQVAsQ0FBVyxnQ0FBWCxFQUhsQjs7SUFLTCxjQUFBLEdBQ0U7TUFBQSxRQUFBLEVBQVUsSUFBQyxDQUFBLFlBQUQsQ0FBQSxDQUFWO01BQ0EsUUFBQSxFQUFVLElBQUMsQ0FBQSxZQUFELENBQUEsQ0FEVjtNQUVBLG1CQUFBLEVBQXFCLE1BQU0sQ0FBQyxRQUFQLENBQWdCLE1BQU0sQ0FBQyxXQUFXLENBQUMsMkJBQW5DLENBRnJCOztJQUdGLElBQUcsWUFBSDtNQUNFLGNBQWMsQ0FBQyxZQUFmLEdBQThCLEtBRGhDOztJQUVBLElBQUEsR0FBTyxDQUFDLENBQUMsTUFBRixDQUFTLElBQVQsRUFBZSxjQUFmLEVBQStCLGtCQUEvQjtXQUNQO0VBaEJNOzttREFrQlIsWUFBQSxHQUFjLFNBQUE7QUFDWixRQUFBO0lBQUEsS0FBQSxHQUFRLE9BQU8sQ0FBQyxPQUFPLENBQUM7SUFDeEIsSUFBRyxLQUFIO01BQ0UsS0FBQSxvQ0FBa0IsQ0FBRSxlQUFaLDJDQUFtQyxDQUFFO01BQzdDLElBQUcsS0FBSDtlQUNFLElBQUksQ0FBQyxTQUFMLENBQWUsMkNBQWYsRUFBNEQ7VUFBQyxTQUFBLEVBQVcsS0FBWjtTQUE1RCxFQURGO09BRkY7O0VBRlk7O21EQU9kLFlBQUEsR0FBYyxTQUFBO0FBQ1osUUFBQTtJQUFBLEtBQUEsR0FBUSxPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxtQkFBN0IsQ0FBQSxDQUFBLHdFQUFtRyxDQUFFO0lBQzdHLElBQUcsS0FBSDthQUNFLElBQUksQ0FBQyxTQUFMLENBQWUsdUNBQWYsRUFBd0Q7UUFBQyxLQUFBLEVBQU8sS0FBUjtPQUF4RCxFQURGOztFQUZZOzttREFLZCxpQkFBQSxHQUFtQixTQUFDLElBQUQ7QUFDakIsUUFBQTtJQUFBLElBQUEsR0FBTyxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBbEIsRUFBd0IsSUFBQyxDQUFBLFNBQXpCO0lBQ1AsS0FBQSxHQUFRLENBQUEsQ0FBRSxJQUFGO0lBQ1IsVUFBQSxHQUFhLElBQUMsQ0FBQSxvQkFBRCxDQUFzQixJQUF0QixFQUE0QixLQUE1QjtXQUNiO0VBSmlCOzttREFNbkIsc0JBQUEsR0FBd0IsU0FBQyxPQUFELEVBQVUsVUFBVixFQUFzQixJQUF0QjtBQUN0QixRQUFBO0lBQUEsV0FBQSxHQUFjLElBQUMsQ0FBQSxxQkFBRCxDQUF1QixPQUF2QixFQUFnQyxVQUFoQztJQUNkLDBCQUFBLENBQTJCLFdBQTNCLEVBQTJDLElBQUQsR0FBTSxHQUFOLEdBQVMsT0FBVCxHQUFpQixPQUEzRDtXQUNBO0VBSHNCOzttREFLeEIsMEJBQUEsR0FBNEIsU0FBQyxxQkFBRCxFQUF3QixVQUF4QjtBQUMxQixRQUFBO0lBQUEsa0JBQUEsR0FBcUIsSUFBQyxDQUFBLHNCQUFELENBQXdCLHFCQUFxQixDQUFDLE9BQTlDLEVBQXVELFVBQXZELEVBQW1FLFNBQW5FO0lBQ3JCLHdCQUFBLENBQXlCLGtCQUF6QjtJQUNBLGtCQUFBLENBQW1CLGtCQUFuQjtXQUNBO0VBSjBCOzttREFNNUIsV0FBQSxHQUFhLFNBQUMsNkJBQUQsRUFBZ0MsVUFBaEM7QUFDWCxRQUFBO0lBQUEsQ0FBQSxDQUFFLDBDQUFGLEVBQThDLFVBQTlDLENBQXlELENBQUMsS0FBMUQsQ0FBQTtBQUNBO1NBQUEsK0RBQUE7O21CQUNFLENBQUEsQ0FBRSwwQ0FBRixFQUE4QyxVQUE5QyxDQUF5RCxDQUFDLE1BQTFELENBQWlFLHFCQUFqRTtBQURGOztFQUZXOzttREFLYixvQkFBQSxHQUFzQixTQUFDLElBQUQsRUFBTyxVQUFQO0FBQ3BCLFFBQUE7SUFBQSw2QkFBQSxHQUFnQztJQUNoQyxJQUFHLDZCQUFIO0FBQ0U7QUFBQSxXQUFBLHFDQUFBOztRQUNFLG1EQUEwQixDQUFFLGdCQUE1QjtVQUNFLGtCQUFBLEdBQXFCLElBQUMsQ0FBQSwwQkFBRCxDQUE0QixlQUFlLENBQUMsT0FBNUMsRUFBcUQsVUFBckQ7VUFDckIsNkJBQTZCLENBQUMsSUFBOUIsQ0FBbUMsa0JBQW5DLEVBRkY7O0FBREY7TUFLQSxJQUFDLENBQUEsV0FBRCxDQUFhLDZCQUFiLEVBQTRDLFVBQTVDLEVBTkY7O1dBT0E7RUFUb0I7O21EQVd0QixxQkFBQSxHQUF1QixTQUFDLElBQUQsRUFBTyxVQUFQO0FBQ3JCLFFBQUE7QUFBQSxZQUFPLElBQVA7QUFBQSxXQUNPLE1BRFA7UUFFSSxXQUFBLEdBQWMsSUFBQyxDQUFBLGdCQUFELENBQWtCLFVBQWxCO0FBRFg7QUFEUCxXQUdPLE9BSFA7UUFJSSxXQUFBLEdBQWMsSUFBQyxDQUFBLGFBQUQsQ0FBZSxVQUFmO0FBRFg7QUFIUCxXQUtPLE9BTFA7UUFNSSxXQUFBLEdBQWMsSUFBQyxDQUFBLGFBQUQsQ0FBZSxVQUFmO0FBTmxCO1dBT0E7RUFScUI7O21EQVV2QixhQUFBLEdBQWUsU0FBQyxVQUFEO1dBQ2IsQ0FBQSxDQUFFLG9FQUFGLEVBQXdFLFVBQXhFO0VBRGE7O21EQUdmLGFBQUEsR0FBZSxTQUFDLFVBQUQ7V0FDYixDQUFBLENBQUUsb0VBQUYsRUFBd0UsVUFBeEU7RUFEYTs7bURBR2YsZ0JBQUEsR0FBa0IsU0FBQyxVQUFEO1dBQ2hCLENBQUEsQ0FBRSxtRUFBRixFQUF1RSxVQUF2RTtFQURnQjs7bURBR2xCLGNBQUEsR0FBZ0IsU0FBQTtJQUNkLElBQUcsSUFBQyxDQUFBLEtBQUssQ0FBQyxHQUFQLENBQVcsZ0JBQVgsQ0FBSDtNQUNFLElBQUcsSUFBQyxDQUFBLEtBQUssQ0FBQyxHQUFQLENBQVcsMEJBQVgsQ0FBSDtRQUNFLElBQUMsQ0FBQSxRQUFRLENBQUMsY0FBVixDQUF5QjtVQUN2QixZQUFBLEVBQWMsUUFEUztVQUV2QixZQUFBLEVBQWMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxhQUFhLENBQUMseUJBQTlCLENBQUEsQ0FGUztTQUF6QixFQURGOzthQUtBLElBQUMsQ0FBQSxRQUFRLENBQUMsY0FBVixDQUF5QjtRQUN2QixZQUFBLEVBQWMsUUFEUztRQUV2QixZQUFBLEVBQWUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxhQUFhLENBQUMsbUJBQTlCLENBQUEsQ0FGUTtRQUd2QixzQkFBQSxFQUF3QixJQUFDLENBQUEsS0FBSyxDQUFDLEdBQVAsQ0FBVywwQkFBWCxDQUhEO09BQXpCLEVBTkY7O0VBRGM7Ozs7R0E3S21DLFFBQVEsQ0FBQzs7QUEwTDlELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
